import axios from "axios";
import { T, APIS } from "../../Constants";

const { IMPORT_API } = APIS;

type StandardActions = T.API.ToAxios<T.API.Utils.Import.StandardActions>;
type GetEquipImportResources = T.API.ToAxios<T.API.Utils.Import.GetEquipImportResources>;
type GetEmplacementImportResources = T.API.ToAxios<T.API.Utils.Import.GetEmplacementImportResources>;

/** Get all the resources necessary for an equipment import */
export const getEquipImportResources: GetEquipImportResources = building => axios.get(IMPORT_API + "data/equip", { params: { building } });
/** Get all the resources necessary for an emplacement import */
export const getEmplacementImportResources: GetEmplacementImportResources = client => axios.get(IMPORT_API + "data/emplacement", { params: { client } });
/** Import a list of standard actions */
export const import_standard_actions: StandardActions = rows => axios.post(IMPORT_API + "standard/actions", { rows });